// import React, { useState, useEffect, useRef } from 'react';
// import './HeroSlider.css';
// // import img1 from '../Home/images/1.png' 

// const HeroSlider = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isHovering, setIsHovering] = useState(false);
//   const autoSlideRef = useRef(null);

//   const slides = [
//     {
//       id: 1,
//       title: "Powering the Country",
//       subtitle: "Dependsable As The Sun",
//       description: "Envisaging a Greener Tomorrow with sustainable energy solutions",
//       // image: "",
//       image: require('../Home/images/residential1.jpg'),
//       color: "#10B981",
//       stats: [
//         { value: "11.5 GWP", label: "Utility Scale Project" },
//         { value: "17 GW", label: "Rooftop Project Commissioned" }
//       ]
//     },
//     {
//       id: 2,
//       title: "Manufacturing Excellence",
//       subtitle: "#1 Rooftop Player",
//       description: "Padma Vibhushan Award Winning Excellence in Solar Manufacturing",
//        image: require('../Home/images/residential2.jpg'),
//       color: "#059669",
//       stats: [
//         { value: "11 LAKH", label: "Solar Water Pump Installed" },
//         { value: "3 GWP", label: "Modules Shipped Worldwide" }
//       ]
//     },
//     {
//       id: 3,
//       title: "National Award Winner",
//       subtitle: "Blue Sky Energy",
//       description: "Simplifying Green Living across India",
//        image: require('../Home/images/residential3.jpg'),
//       color: "#065F46",
//       stats: [
//         { value: "993 MW", label: "Wind Energy Capacity" },
//         { value: "20+", label: "Years of Experience" }
//       ]
//     },
//     {
//       id: 4,
//       title: "Latest Installations",
//       subtitle: "Our Most Recent Projects",
//       description: "View our recent green energy projects across Maharashtra",
//        image: require('../Home/images/residential4.jpg'),
//       color: "#047857",
//       stats: [
//         { value: "5000+", label: "Completed Projects" },
//         { value: "500+", label: "Corporate Clients" }
//       ]
//     }
    
//   ];

//   // Navigation items (right side text)
//   const navItems = [
//     { id: 0, title: "Powering the Country", subtitle: "Dependsable As The Sun" },
//     { id: 1, title: "Manufacturing Excellence", subtitle: "#1 Rooftop Player" },
//     { id: 2, title: "National Award Winner", subtitle: "Blue Sky Energy " },
//     { id: 3, title: "Latest Installations", subtitle: "Our Recent Projects" }
//   ];

//   // Auto slide functionality
//   useEffect(() => {
//     if (!isHovering) {
//       autoSlideRef.current = setInterval(() => {
//         setCurrentSlide((prev) => (prev + 1) % slides.length);
//       }, 5000);
//     }

//     return () => {
//       if (autoSlideRef.current) {
//         clearInterval(autoSlideRef.current);
//       }
//     };
//   }, [isHovering, slides.length]);

//   const handleNavHover = (index) => {
//     setIsHovering(true);
//     setCurrentSlide(index);
//     if (autoSlideRef.current) {
//       clearInterval(autoSlideRef.current);
//     }
//   };

//   const handleNavLeave = () => {
//     setIsHovering(false);
//   };

//   const handleNavClick = (index) => {
//     setCurrentSlide(index);
//   };

//   return (
//     <div className="hero-slider-container">
//       <div className="slider-wrapper">
//         {/* Main Slideshow */}
//         <div className="slideshow">
//           {slides.map((slide, index) => (
//             <div 
//               key={slide.id} 
//               className={`slide ${index === currentSlide ? 'active' : ''}`}
//               style={{ 
//                 backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${slide.image})`,
//                 backgroundColor: slide.color
//               }}
//             >
//               <div className="slide-content">
//                 <div className="slide-text">
//                   <h1 className="slide-title fade-in-text">
//                     {slide.title}
//                   </h1>
//                   <h2 className="slide-subtitle fade-in-text">
//                     {slide.subtitle}
//                   </h2>
//                   <p className="slide-description fade-in-text">
//                     {slide.description}
//                   </p>
//                 </div>
                
//                 <div className="slide-stats fade-in-text">
//                   {slide.stats.map((stat, idx) => (
//                     <div key={idx} className="stat-item">
//                       <div className="stat-value">{stat.value}</div>
//                       <div className="stat-label">{stat.label}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           ))}
          
//           {/* Slide Dots Indicator */}
//           <div className="slide-dots">
//             {slides.map((_, index) => (
//               <button
//                 key={index}
//                 className={`dot ${index === currentSlide ? 'active' : ''}`}
//                 onClick={() => setCurrentSlide(index)}
//               />
//             ))}
//           </div>
//         </div>

//         {/* Right Side Navigation */}
//         <div className="slider-navigation">
//           <div className="nav-header">
//             <h3>Our Journey</h3>
//             <p>Hover or click to explore</p>
//           </div>
          
//           <div className="nav-items">
//             {navItems.map((item, index) => (
//               <div
//                 key={item.id}
//                 className={`nav-item ${index === currentSlide ? 'active' : ''}`}
//                 onMouseEnter={() => handleNavHover(index)}
//                 onMouseLeave={handleNavLeave}
//                 onClick={() => handleNavClick(index)}
//               >
//                 <div className="nav-item-content">
//                   <div className="nav-item-title">{item.title}</div>
//                   <div className="nav-item-subtitle">{item.subtitle}</div>
//                 </div>
//                 <div className="nav-item-indicator">
//                   <div className="indicator-bar"></div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Contact Info (from your image) */}
//           <div className="contact-info-sidebar">
//             <div className="contact-item">
//               <div className="contact-icon">📞</div>
//               <div className="contact-details">
//                 <div className="contact-label">Call Us</div>
//                 <div className="contact-value">(+91) 080879 32436</div>
//               </div>
//             </div>
//             <div className="contact-item">
//               <div className="contact-icon">✉️</div>
//               <div className="contact-details">
//                 <div className="contact-label">Email</div>
//                 <div className="contact-value">info@greenlifesolution.in</div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Strengths Section (from your image) */}
//       <div className="strengths-section">
//         <div className="container">
//           <h2 className="strengths-title">Our Strengths</h2>
//           <div className="strengths-grid">
//             <div className="strength-card">
//               <div className="strength-value animate-number">5000 +</div>
//               <div className="strength-label">Completed Projects</div>
//             </div>
//             <div className="strength-card">
//               <div className="strength-value animate-number">500 +</div>
//               <div className="strength-label">Corporate Clients</div>
//             </div>
//             <div className="strength-card">
//               <div className="strength-value animate-number">20 +</div>
//               <div className="strength-label">MWP Operating Capacity</div>
//             </div>
//             <div className="strength-card">
//               <div className="strength-value animate-number">5 +</div>
//               <div className="strength-label">Years Experience</div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSlider;




























import React, { useState, useEffect, useRef } from 'react';
import './HeroSlider.css';
// import img1 from '../Home/images/1.png' 

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const autoSlideRef = useRef(null);

  const slides = [
    {
      id: 1,
      title: "Powering the Country",
      subtitle: "Dependsable As The Sun",
      description: "Envisaging a Greener Tomorrow with sustainable energy solutions",
      // image: "",
      image: require('../Home/images/residential1.jpg'),
      color: "#447793",
      stats: [
        { value: "11.5 GWP", label: "Utility Scale Project" },
        { value: "17 GW", label: "Rooftop Project Commissioned" }
      ]
    },
    {
      id: 2,
      title: "Manufacturing Excellence",
      subtitle: "#1 Rooftop Player",
      description: "Padma Vibhushan Award Winning Excellence in Solar Manufacturing",
       image: require('../Home/images/residential2.jpg'),
      color: "#2D5A74",
      stats: [
        { value: "11 LAKH", label: "Solar Water Pump Installed" },
        { value: "3 GWP", label: "Modules Shipped Worldwide" }
      ]
    },
    {
      id: 3,
      title: "National Award Winner",
      subtitle: "Blue Sky Energy",
      description: "Simplifying Green Living across India",
       image: require('../Home/images/residential3.jpg'),
      color: "#123249",
      stats: [
        { value: "993 MW", label: "Wind Energy Capacity" },
        { value: "20+", label: "Years of Experience" }
      ]
    },
    {
      id: 4,
      title: "Latest Installations",
      subtitle: "Our Most Recent Projects",
      description: "View our recent green energy projects across Maharashtra",
       image: require('../Home/images/residential4.jpg'),
      color: "#061221",
      stats: [
        { value: "5000+", label: "Completed Projects" },
        { value: "500+", label: "Corporate Clients" }
      ]
    }
    
  ];

  // Navigation items (right side text)
  const navItems = [
    { id: 0, title: "Powering the Country", subtitle: "Dependsable As The Sun" },
    { id: 1, title: "Manufacturing Excellence", subtitle: "#1 Rooftop Player" },
    { id: 2, title: "National Award Winner", subtitle: "Blue Sky Energy " },
    { id: 3, title: "Latest Installations", subtitle: "Our Recent Projects" }
  ];

  // Auto slide functionality
  useEffect(() => {
    if (!isHovering) {
      autoSlideRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 5000);
    }

    return () => {
      if (autoSlideRef.current) {
        clearInterval(autoSlideRef.current);
      }
    };
  }, [isHovering, slides.length]);

  const handleNavHover = (index) => {
    setIsHovering(true);
    setCurrentSlide(index);
    if (autoSlideRef.current) {
      clearInterval(autoSlideRef.current);
    }
  };

  const handleNavLeave = () => {
    setIsHovering(false);
  };

  const handleNavClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="hero-slider-container">
      <div className="slider-wrapper">
        {/* Main Slideshow */}
        <div className="slideshow">
          {slides.map((slide, index) => (
            <div 
              key={slide.id} 
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{ 
                backgroundImage: `linear-gradient(rgba(6, 18, 33, 0.6), rgba(6, 18, 33, 0.6)), url(${slide.image})`,
                backgroundColor: slide.color
              }}
            >
              <div className="slide-content">
                <div className="slide-text">
                  <h1 className="slide-title fade-in-text">
                    {slide.title}
                  </h1>
                  <h2 className="slide-subtitle fade-in-text">
                    {slide.subtitle}
                  </h2>
                  <p className="slide-description fade-in-text">
                    {slide.description}
                  </p>
                </div>
                
                <div className="slide-stats fade-in-text">
                  {slide.stats.map((stat, idx) => (
                    <div key={idx} className="stat-item">
                      <div className="stat-value">{stat.value}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          
          {/* Slide Dots Indicator */}
          <div className="slide-dots">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>

        {/* Right Side Navigation */}
        <div className="slider-navigation">
          <div className="nav-header">
            <h3>Our Journey</h3>
            <p>Hover or click to explore</p>
          </div>
          
          <div className="nav-items">
            {navItems.map((item, index) => (
              <div
                key={item.id}
                className={`nav-item ${index === currentSlide ? 'active' : ''}`}
                onMouseEnter={() => handleNavHover(index)}
                onMouseLeave={handleNavLeave}
                onClick={() => handleNavClick(index)}
              >
                <div className="nav-item-content">
                  <div className="nav-item-title">{item.title}</div>
                  <div className="nav-item-subtitle">{item.subtitle}</div>
                </div>
                <div className="nav-item-indicator">
                  <div className="indicator-bar"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Contact Info (from your image) */}
          <div className="contact-info-sidebar">
            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <div className="contact-details">
                <div className="contact-label">Call Us</div>
                <div className="contact-value">(+91) 080879 32436</div>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div className="contact-details">
                <div className="contact-label">Email</div>
                <div className="contact-value">info@blueskyenergy.in</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Strengths Section (from your image) */}
      <div className="strengths-section">
        <div className="container">
          <h2 className="strengths-title">Our Strengths</h2>
          <div className="strengths-grid">
            <div className="strength-card">
              <div className="strength-value animate-number">5000 +</div>
              <div className="strength-label">Completed Projects</div>
            </div>
            <div className="strength-card">
              <div className="strength-value animate-number">500 +</div>
              <div className="strength-label">Corporate Clients</div>
            </div>
            <div className="strength-card">
              <div className="strength-value animate-number">20 +</div>
              <div className="strength-label">MWP Operating Capacity</div>
            </div>
            <div className="strength-card">
              <div className="strength-value animate-number">5 +</div>
              <div className="strength-label">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;